import { Check } from "lucide-react";
import { ParceirosHeroForm } from "./ParceirosHeroForm";
import { Eyebrow } from "./Eyebrow";

const BULLETS = [
  "Exclusivo para profissionais certificados com carteira ativa",
  "Produto fora da prateleira convencional",
  "Remuneração pelo volume que você divulga",
  "Estrutura 100% regulada pela CVM (CVM88)",
];

export const ParceirosHero = () => {
  return (
    <section className="relative bg-[#FAF8F5]">
      <div className="container-wide pt-10 pb-12 sm:pt-14 sm:pb-20 md:pt-20 md:pb-24">
        <div className="grid gap-10 lg:gap-16 lg:grid-cols-12 items-start">
          {/* Coluna esquerda — texto (60% desktop) */}
          <div className="lg:col-span-7">
            <div>
              <Eyebrow className="mb-5 sm:mb-6">
                Programa de Parceiros · Allu Invest
              </Eyebrow>
            </div>

            <div>
              <h1
                className="text-[#323F4F] font-bold leading-[1.05] tracking-tight text-[2rem] sm:text-5xl md:text-[3.25rem] lg:text-6xl"
                style={{
                  fontFamily:
                    '"Plus Jakarta Sans", Inter, system-ui, sans-serif',
                  letterSpacing: "-0.03em",
                }}
              >
                O mercado de assessoria virou commodity.{" "}
                <span className="text-[#2E694D]">
                  Divulgue o que ninguém mais oferece.
                </span>
              </h1>
            </div>

            <div>
              <p className="mt-4 sm:mt-5 text-base sm:text-lg font-semibold text-[#2E694D] max-w-2xl">
                Para assessores, consultores e family offices com carteira ativa
                de clientes.
              </p>
            </div>

            <div>
              <p className="text-base sm:text-lg text-zinc-600 leading-relaxed mt-5 sm:mt-6 max-w-2xl">
                Leve aos seus clientes um produto de{" "}
                <strong className="text-[#323F4F] font-semibold">
                  crédito estruturado securitizado com lastro real
                </strong>
                , 100% regulado pela CVM, com 10 anos de operação e 100% de
                adimplência — fora da prateleira que todo escritório oferece.
              </p>
            </div>

            <div>
              <ul className="mt-7 sm:mt-9 space-y-3 max-w-xl">
                {BULLETS.map((b) => (
                  <li key={b} className="flex items-start gap-3">
                    <span className="mt-0.5 inline-flex items-center justify-center w-5 h-5 rounded-full bg-[#D1F8E2] flex-shrink-0">
                      <Check className="w-3 h-3 text-[#112711]" strokeWidth={3} />
                    </span>
                    <span className="text-sm sm:text-base text-[#323F4F]">
                      {b}
                    </span>
                  </li>
                ))}
              </ul>
            </div>

            <div>
              <p className="mt-6 sm:mt-7 max-w-xl border-t border-zinc-200/70 pt-4 text-xs sm:text-sm text-zinc-500 leading-relaxed">
                Atendemos apenas profissionais do mercado, com registro ou
                certificação e clientes ativos. Não é uma oportunidade de
                investimento para o público final.
              </p>
            </div>
          </div>

          {/* Coluna direita — form (40% desktop, abaixo no mobile) */}
          <div className="lg:col-span-5">
            <div>
              <ParceirosHeroForm />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
